import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5850930a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-editor-file-widget" }

import {
  TirPmFilePreview,
  FilePreviewVariantEnum,
  IFilePreview,
} from "tir-pm-file-preview";
import { computed, PropType } from "vue";
import { ITextEditorFile } from "../interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditorFileWidget',
  props: {
  /**Файл */
  file: {
    type: Object as PropType<ITextEditorFile>,
    required: true,
  },
  /**Список файлов */
  files: {
    type: Array as PropType<Array<ITextEditorFile>>,
    default: [],
  },
  /**Загрузка при редактировании названия файла */
  filesLoadingEditName: {
    type: Array as PropType<Array<string | number>>,
    default: [],
  },
},
  emits: ["onClickDeleteFile", "onClickEditFile", "saveName"],
  setup(__props, { emit }) {

const props = __props;



const emitSaveName = (fileId: string | number, fileName: string) =>
  emit("saveName", fileId, fileName);



const convertFile = (file: ITextEditorFile): IFilePreview => {
  const user = file.User;

  return {
    FileId: file.FileId,
    Url: file.Url,
    VideoPreviewUrl: file.VideoPreviewUrl,
    Name: file.Name,
    Size: file.Size,
    DateUpload: file.DateUpload,
    User: user && {
      Id: user.Id,
      FirstName: user.FirstName,
      LastName: user.LastName,
      MiddleName: user.MiddleName,
      AvatarColor: user.AvatarColor,
      Image: user.Image,
    },
    Accesses: file.Accesses,
    Progress: file.Progress,
    IsProccessing: file.IsProccessing,
  };
};

const previewFile = computed(() => convertFile(props.file));
const previewFiles = computed(() => props.files.map(convertFile));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmFilePreview), {
      file: previewFile.value,
      files: previewFiles.value,
      variant: _unref(FilePreviewVariantEnum).Small,
      "no-media-variant": _unref(FilePreviewVariantEnum).Inline,
      "files-loading-edit-name": __props.filesLoadingEditName,
      onOnClickDelete: _cache[0] || (_cache[0] = ($event: any) => (emit('onClickDeleteFile'))),
      onOnClickEdit: _cache[1] || (_cache[1] = ($event: any) => (emit('onClickEditFile', $event))),
      onSaveName: emitSaveName
    }, null, 8, ["file", "files", "variant", "no-media-variant", "files-loading-edit-name"])
  ]))
}
}

})